/**
 * Crew Definitions and Constants
 * UK Workboat Code Edition 3 - Basic crew position and status definitions
 */

export const CREW_POSITIONS = [
  // Core Workboat Positions
  "Skipper",
  "Master",
  "Mate",
  "Engineer",
  "Deckhand",
  "Crew",
  "Trainee",
  
  // Specialist Workboat Roles
  "Crane Operator",
  "Winch Operator",
  "Banksman",
  "Survey Technician",
  "Dive Technician",
  "Safety Officer",
  
  // Passenger Operations
  "Passenger Assistant",
  
  // Keep for larger vessels/compatibility
  "Chief Officer",
  "Chief Engineer",
  "Second Engineer",
  
  // Generic
  "Other"
];

export const CREW_STATUS = [
  "Active",
  "Inactive", 
  "On Leave",
  "Training"
];

export const VESSEL_EXPERIENCE_LEVELS = [
  "New",
  "Training", 
  "Experienced"
];

// Certificate types for tracking (WBC3 Section 11.4, Section 11.5, MSN 1856)
export const CERTIFICATE_TYPES = [
  // STCW Basic Safety Training (Mandatory for all crew)
  'STCW Basic Safety Training',
  'Personal Survival Techniques',
  'Fire Prevention & Fire Fighting',
  'Elementary First Aid',
  'Personal Safety & Social Responsibilities',
  
  // Medical Certificates
  'ENG1 Medical Certificate',
  'ML5 Medical Certificate',
  
  // Certificates of Competency
  'STCW Master (Workboat <500GT)',
  'STCW Master <200GT',
  'STCW Master (Code Vessels <200GT unlimited)',
  'STCW Master (Code Vessels <200GT 150nm limit)',
  'Master 500GT',
  'Chief Mate <500GT',
  'OOW <500GT',
  'Boatmaster License',
  'RYA Yachtmaster Ocean',
  'RYA Yachtmaster Offshore', 
  'RYA Yachtmaster Coastal',
  'RYA Yachtmaster Commercial',
  'RYA Day Skipper',
  'RYA Advanced Powerboat Commercial',
  'RYA Powerboat Level 2 Commercial',
  'Local Authority License',
  
  // Radio Certificates
  'GMDSS GOC',
  'GMDSS ROC',
  'VHF DSC Radio Operator',
  
  // Additional Training
  'Security Awareness',
  'Designated Security Duties',
  'Proficiency in Survival Craft',
  'Advanced Fire Fighting',
  'Medical First Aid',
  'Medical Care',
  'HELM Training',

  // FT-30: Equipment-linked training certificates (WBC3 Table A5.3)
  'Radar/ARPA Training',
  'ECS Training',                                    // Chart plotter - MCA Small Ships Navigation: ECS and Bridge Watchkeeping
  'ECDIS Training',                                  // Full ECDIS system - Appropriate ECDIS Training per MIN 698
  'Stability Training',                              // MCA approved 1-day stability course - Master only when SIB required (WBC3 Table A5.3)
  'Ship\'s Cook Certificate / Catering Training',
  'MGO Transfer Training',
  
  // Engine Qualifications
  'Marine Engine Operator License (MEOL)',
  'Senior Marine Engine Operator License (SMEOL)',
  'Small Vessel Second Engineer CoC',
  'STCW III/2 Small Vessel Chief Engineer',
  'AEC Part 1',
  'Engineering Officer <9000kW',
  'Engineering Officer <3000kW',
  
  // Other Specialist
  'Dangerous Goods',
  'Passenger Safety',
  'Crisis Management',
  'Crowd Management',
  'Other'
];

// Default emergency roles assignment
export const EMERGENCY_ROLES = [
  "Fire Team Leader",
  "Fire Team Member", 
  "Search & Rescue Coordinator",
  "First Aid Officer",
  "Evacuation Coordinator",
  "Radio Operator",
  "Engine Room Emergency",
  "General Crew"
];